export default __webpack_public_path__ + "static/media/c3.6e7384e8.jpeg";